export default __webpack_public_path__ + "static/8_19-83b2d174b7e175abc4e205008d35f321.png";